<template>
    <div class="container mt-5" v-if="text" v-html="text">

    </div>
</template>

<script>
export default {
    name: 'Paymentmethod',
    components: {},
    props: {},
    data () {
        return {
            text: null
        }
    },
    computed: {},
    created () {
        this.$http
            .get('paymentmethod')
            .then(response => {
                this.text = response.data.data
            })
            .catch(error => {
            })
            .finally(() => this.loading = false)
    },
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>